import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import moment from "moment";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const userStatusColors: Record<string, "success" | "error" | "secondary"> = {
  active: "success",
  inactive: "error",
  pending: "secondary",
};

const userTypeColors: Record<string, "success" | "error" | "secondary"> = {
  seller: "success",
  buyer: "error",
  agent: "secondary",
};

const formatDate = (dateString: string) => {
  return moment(dateString).fromNow();
};

const formatTableDate = (dateString: string) => {
  return moment(dateString).format("MMM, DD-YYYY");
};

const formatPrice = (price: string | number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
  }).format(Number(price));
};

// const formatPrice = (price: string) => {
//   return new Intl.NumberFormat("en-IE", {
//     style: "currency",
//     currency: "EUR",
//     minimumFractionDigits: 0,
//   }).format(Number(price));
// };

function formatTick(ts: Date, unit: String) {
  const d = new Date(ts);
  if (unit === "day") return d.toLocaleTimeString([], { hour: "2-digit" });
  if (unit === "year")
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  return d.toLocaleDateString();
}

const gradientColors: string[] = [
  "linear-gradient(45deg, #ff9a9e, #fad0c4)", // soft pink → peach
  "linear-gradient(45deg, #a18cd1, #fbc2eb)", // lavender → pink
  "linear-gradient(45deg, #fad0c4, #ffd1ff)", // peach → light violet
  "linear-gradient(45deg, #ffecd2, #fcb69f)", // cream → orange
  "linear-gradient(45deg, #f6d365, #fda085)", // yellow → coral
  "linear-gradient(45deg, #fbc2eb, #a6c1ee)", // pink → light blue
  "linear-gradient(45deg, #fdcbf1, #e6dee9)", // pastel pink → gray
  "linear-gradient(45deg, #a1c4fd, #c2e9fb)", // sky blue → teal
  "linear-gradient(45deg, #fddb92, #d1fdff)", // gold → aqua
  "linear-gradient(45deg, #89f7fe, #66a6ff)", // cyan → blue
  "linear-gradient(45deg, #667eea, #764ba2)", // indigo → violet
  "linear-gradient(45deg, #9890e3, #b1f4cf)", // purple → mint
  "linear-gradient(45deg, #f6d365, #fda085)", // soft orange → peach
  "linear-gradient(45deg, #ff9a9e, #fecfef)", // rose → blush
  "linear-gradient(45deg, #30cfd0, #330867)", // teal → deep purple
  "linear-gradient(45deg, #5ee7df, #b490ca)", // turquoise → lavender
  "linear-gradient(45deg, #d299c2, #fef9d7)", // pink → cream
  "linear-gradient(45deg, #cfd9df, #e2ebf0)", // silver → white
  "linear-gradient(45deg, #a8edea, #fed6e3)", // aqua → blush
  "linear-gradient(45deg, #ffdde1, #ee9ca7)", // light pink → darker pink
];

const statusLabels: any = {
  scheduled: "Scheduled",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
};

const statusColors: any = {
  scheduled: "warning",
  in_progress: "secondary",
  completed: "success",
  cancelled: "error",
};

const propertyType: any = {
  residential: "Residential",
  commercial: "Commercial",
  mixed: "Mixed",
  industrial: "Industrial",
  hospitality: "Hospitality",
};

function firstPanelDate(value: any) {
  // AntD Calendar shows extra days from previous/next months in the grid.
  // Compute panel month range: first day of month -> last day of month.
  const start = value.startOf("month");
  const end = value.endOf("month");
  return { start, end };
}

function formatYMD(dj: any) {
  return dj.format("YYYY-MM-DD");
}

export const MessageTypes : any = {
  reminder: "Reminder",
  announcement: "Announcement",
  alert: "Alert",
};

export const MessageTypeColors : any = {
  reminder: "warning",
  announcement: "secondary",
  alert: "error",
};

export {
  statusColors,
  formatDate,
  formatPrice,
  formatTick,
  userStatusColors,
  userTypeColors,
  formatTableDate,
  gradientColors,
  propertyType,
  statusLabels,
  firstPanelDate,
  formatYMD,
};
